<template>
<div class="chapter">
<div class="inner_page">
<h1 class="P_Heading_1" id="auto_bookmark_toc_1"><span>Refraction</span></h1>
<p class="P_Normal"> </p>
<p class="P_Norm-NoIndent">By Jodi Payne and BA Tortuga</p>
<p class="P_Norm-NoIndent">A Collaborations Novel</p>
<p class="P_Normal"> </p>
<p class="P_Normal">Texas artist Tucker Williams arrives in New York City for a gallery showing of his work and finds the city blanketed in snow. He meets free-spirited underwear model Calvin McIntire on the steps of the Midtown library and is captivated by a wild beauty that manages to compete with the demons that occupy his soul and fuel his work with their lust for blood and erotic imagery.</p>
<p class="P_Normal">Unable to deny a new inspiration, Tucker sublets a studio and finds the city’s energy almost as addictive as Calvin.</p>
<p class="P_Normal">Tucker is obsessive, barely holding on to sanity as his art consumes him, and Calvin is dealing with demons of his own, trying desperately to protect his soul in a business where only his appearance has value. They each prove to be the perfect remedy for the other’s personal brand of crazy until, in the midst of stress and exhaustion, they discover that a promise Calvin needs is the one thing Tucker can’t give him, and their heaven turns to purgatory.</p>
<p class="P_Normal">Can both men find a path toward wholeness in Tucker’s beautiful but chaotic Texas home? In order for them—and their passionate relationship—to thrive, they’ll need to adapt, share their psychoses, and find a true balance between New York City and rural Texas.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0002.vue?21866790